import { SEO } from '../components/SEO';
import { generateOrganizationSchema, getBaseUrl } from '../utils/seo';
import './TermsPage.css';

/**
 * SEO-optimized Terms of Service Page
 */
export function TermsPage() {
  const structuredData = [
    generateOrganizationSchema(getBaseUrl()),
  ];

  return (
    <>
      <SEO
        title="Terms of Service - Peptide Finder"
        description="Read our terms of service to understand the rules and guidelines for using Peptide Finder."
        keywords="terms of service, user agreement, terms and conditions"
        structuredData={structuredData}
      />
      <div className="terms-page">
        <header className="terms-page-header">
          <div className="terms-page-container">
            <h1>Terms of Service</h1>
            <p className="terms-page-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </header>

        <main className="terms-page-main">
          <div className="terms-page-container">
            <article className="terms-page-content">
              <section>
                <h2>Agreement to Terms</h2>
                <p>
                  By accessing or using Peptide Finder (&quot;the Service&quot;), you agree to be bound by these Terms of Service (&quot;Terms&quot;). If you disagree with any part of these terms, you may not access the Service.
                </p>
              </section>

              <section>
                <h2>Use License</h2>
                <p>
                  Permission is granted to temporarily use the Service for personal, non-commercial use only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul>
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display</li>
                  <li>Attempt to reverse engineer any software contained in the Service</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </section>

              <section>
                <h2>Disclaimer</h2>
                <p>
                  The information on this Service is provided on an &quot;as is&quot; basis. To the fullest extent permitted by law, we exclude all representations, warranties, and conditions relating to our Service and the use of this Service.
                </p>
                <p>
                  We do not warrant that the Service will be available at all times or that it will be error-free. The Service may be subject to interruptions, delays, or other problems inherent in the use of the internet and electronic communications.
                </p>
              </section>

              <section>
                <h2>Limitations</h2>
                <p>
                  In no event shall Peptide Finder or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the Service, even if we have been notified orally or in writing of the possibility of such damage.
                </p>
              </section>

              <section>
                <h2>Accuracy of Information</h2>
                <p>
                  The materials appearing on the Service could include technical, typographical, or photographic errors. We do not warrant that any of the materials on the Service are accurate, complete, or current. We may make changes to the materials contained on the Service at any time without notice.
                </p>
              </section>

              <section>
                <h2>Links to Third-Party Sites</h2>
                <p>
                  The Service may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
                </p>
              </section>

              <section>
                <h2>Prohibited Uses</h2>
                <p>You may not use the Service:</p>
                <ul>
                  <li>In any way that violates any applicable law or regulation</li>
                  <li>To transmit any malicious code or viruses</li>
                  <li>To attempt to gain unauthorized access to any portion of the Service</li>
                  <li>To interfere with or disrupt the Service or servers connected to the Service</li>
                </ul>
              </section>

              <section>
                <h2>Intellectual Property</h2>
                <p>
                  The Service and its original content, features, and functionality are owned by Peptide Finder and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                </p>
              </section>

              <section>
                <h2>Termination</h2>
                <p>
                  We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
              </section>

              <section>
                <h2>Changes to Terms</h2>
                <p>
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
                </p>
              </section>

              <section>
                <h2>Contact Information</h2>
                <p>
                  If you have any questions about these Terms of Service, please contact us through the app or website.
                </p>
              </section>
            </article>
          </div>
        </main>
      </div>
    </>
  );
}

